module.exports = __webpack_public_path__ + "static/media/55_000019.d431c431.jpg";